<template>
  <div
    v-if="showToast"
    class="
      toast-notify
      left-4
      p-1
      bg-easy-grey
      rounded-xl
      gap-1
      border-2 border-easy-grey
      hover:border-yellow
      z-20
    "
    style="top: 8rem; height: 3.5rem"
  >
    <span class="text-sm flex items-center pr-4">
      <EyeIcon class="h-6 w-6 mx-2 text-vice-teal-700" />
      You are participating as observer in this session. You cannot talk and your
      <br />
      camera is off. You can ask questions at any time in the chat.
    </span>
    <button @click="closeToast">
      <CrossSimpleIcon type="link" class="text-vice-dark-grey hover:text-strong-grey" />
    </button>
  </div>
</template>

<script>
import { EyeIcon } from '@heroicons/vue/solid';
import { onMounted, onUnmounted, ref } from 'vue';
import CrossSimpleIcon from '@/Components/Icons/CrossSimpleIcon.vue';
import useSessionStore from '@/Stores/useSessionStore';

export default {
  name: 'ObserverInfoToast',
  components: { EyeIcon, CrossSimpleIcon },
  setup() {
    const showToast = ref(true);
    const sessionStore = useSessionStore();

    const closeToast = () => {
      showToast.value = false;
    };

    onMounted(() => {
      sessionStore.toastCount += 1;
      // Automatically hide the toast after 3 min
      setTimeout(() => {
        closeToast();
      }, 180000); // 180 000 ms = 3 min
    });

    onUnmounted(() => {
      sessionStore.toastCount -= 1;
    });

    return { closeToast, showToast };
  },
};
</script>

<style scoped></style>
